import styled from 'styled-components';

type FlexDirection = 'row' | 'row-reverse' | 'column' | 'column-reverse';
type JustifyContent =
  | 'flex-start'
  | 'flex-end'
  | 'center'
  | 'space-between'
  | 'space-around'
  | 'space-evenly';
type AlignItems = 'stretch' | 'flex-start' | 'flex-end' | 'center' | 'baseline';
type AlignContent =
  | 'stretch'
  | 'flex-start'
  | 'flex-end'
  | 'center'
  | 'space-between'
  | 'space-around'
  | 'space-evenly';
type FlexWrap = 'nowrap' | 'wrap' | 'wrap-reverse';
type FlexGrow = number;
type FlexShrink = number;
type FlexBasis = string | number;

interface FlexBoxProps {
  flexDirection?: FlexDirection;
  justifyContent?: JustifyContent;
  alignItems?: AlignItems;
  alignContent?: AlignContent;
  flexWrap?: FlexWrap;
  gap?: string | number;
  flexGrow?: FlexGrow;
  flexChildrenGrow?: FlexGrow;
  flexShrink?: FlexShrink;
  flexBasis?: FlexBasis;
  width?: string | number;
  height?: string | number;
  lastChildFlex?: boolean; // New prop to conditionally apply flex: 1 to the last child
  lastChildNoWrap?: boolean;
}

const AppFlexBox = styled.div<FlexBoxProps>`
  display: flex;

  flex-direction: ${({ flexDirection = 'row' }) => flexDirection};
  justify-content: ${({ justifyContent = 'flex-start' }) => justifyContent};
  align-items: ${({ alignItems = 'stretch' }) => alignItems};
  align-content: ${({ alignContent = 'stretch' }) => alignContent};
  flex-wrap: ${({ flexWrap = 'nowrap' }) => flexWrap};

  gap: ${({ gap = '0px' }) => gap}; /* Flex gap */
  flex-grow: ${({ flexGrow = 0 }) => flexGrow};
  flex-shrink: ${({ flexShrink = 1 }) => flexShrink};
  flex-basis: ${({ flexBasis = 'auto' }) => flexBasis};

  width: ${({ width = 'auto' }) => width};
  height: ${({ height = 'auto' }) => height};

  & > * {
    flex: ${({ flexChildrenGrow = 0 }) => (flexChildrenGrow ? 1 : 'initial')};
  }
  & > :last-child {
    flex: ${({ lastChildFlex = false }) => (lastChildFlex ? 1 : 'initial')};
    white-space: ${({ lastChildNoWrap = false }) =>
      lastChildNoWrap ? 'nowrap' : 'normal'};
  }
`;

export default AppFlexBox;
